import {http} from './config/config-relation-register'

export default{
    listar:(token)=>{
        return  http.get('grupos-quimicos',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('grupos-quimicos',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('grupos-quimicos/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('grupos-quimicos/'+item.id_grupo_quimico,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}